import {useState} from "react";
import {useTranslation} from "react-i18next";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

/*
 * «Elektron murojaatlar» bloki — bosh sahifa ochilganda birinchi ko'rinadi.
 *
 * Murojaatlar platformasi alohida domenda (murojaatlar.uzkoj.uz), shuning
 * uchun barcha havolalar tashqi: yangi oynada ochiladi va `noopener`
 * bilan himoyalanadi.
 *
 * Blok yopilsa, tanlov sessiya davomida eslab qolinadi. Brauzer yopilgach
 * u yana ko'rinadi: murojaat yuborish — saytning asosiy xizmatlaridan biri,
 * uni doimiy yashirib qo'yish noto'g'ri.
 */
const BASE = 'https://murojaatlar.uzkoj.uz';
const STORAGE_KEY = 'E_APPEALS_BANNER_CLOSED';

function readClosed() {
    try {
        return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export default function EAppealsBanner() {
    const {t} = useTranslation();
    const [closed, setClosed] = useState(readClosed);

    if (closed) return null;

    function close() {
        try {
            window.sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (e) { /* sessionStorage o'chirilgan bo'lsa ham blok yopiladi */ }
        setClosed(true);
    }

    const hint = t('e_appeals_new_tab');

    return (
        <section className="e-appeals-banner mb-3" aria-labelledby="e-appeals-title">
            <div className="container">
                <div className="e-appeals-inner">
                    <div className="e-appeals-text">
                        <h2 id="e-appeals-title">{t('e_appeals_title')}</h2>
                        <p>{t('e_appeals_text')}</p>
                    </div>
                    <div className="e-appeals-actions">
                        <a className="e-appeals-main"
                           href={`${BASE}`}
                           target="_blank" rel="noopener noreferrer">
                            {t('e_appeals_go')}
                            <ArrowForwardIcon aria-hidden="true"/>
                            <span className="visually-hidden"> ({hint})</span>
                        </a>
                    </div>
                    <button type="button" className="e-appeals-close" onClick={close}
                            aria-label={t('e_appeals_close')}>
                        <CloseIcon aria-hidden="true"/>
                    </button>
                </div>
            </div>
        </section>
    );
}
